import { useFileUrl } from "../lib/useFileUrl.js";

/**
 * An inline preview of a file the API protects.
 *
 * A component rather than a bare `<img>` so every protected preview goes
 * through `useFileUrl`, and a hook cannot be called from inside the `.map()`
 * that renders a grid of these.
 */
export function FilePreview({
  fileId,
  alt,
  className,
}: {
  fileId: string;
  alt: string;
  className?: string;
}) {
  const src = useFileUrl(`/api/v1/files/${fileId}/preview`);
  if (!src) return null;
  return <img src={src} alt={alt} loading="lazy" className={className} />;
}
